/**
 * Header Layout
 *
 * @file header.js
 */

import $ from "jquery";

const header = (() => {
  const menu = () => {
    if(window.innerWidth <= 992){
      $("header .main-nav .main-nav__item").on("click", function(){
        $(this).find(".sub-menu").toggleClass("mobile-active");
      });
    } else{
      $("header .main-nav .main-nav__item").hover(function(){
        $(this).find(".sub-menu").css("display","flex");
      }, function(){
        $(this).find(".sub-menu").css("display","none");
      });
    }
    $("header nav.main-nav ul> li.main-nav__item").hover(function(){
      $(".backdrop-overlay").addClass("active");
    }, function(){
      $(".backdrop-overlay").removeClass("active");
    })
  };

  const mobileHamburger = () => {
    var hamburger = document.querySelector('.mobile-hamburger');
    var mainNav = document.querySelector('.main-nav');
    hamburger.addEventListener('click', function() {
        this.classList.toggle('menu-open');
        mainNav.classList.toggle('menu-open');
        $("html,body").toggleClass("u-noscroll");
    });
  };

  const headerSearch = () => {
    document.querySelector(".hd-search").addEventListener("click", function() {
      document.querySelector(".full-search").classList.toggle("search-active");
      setTimeout(function() {
          document.querySelector(".full-search").querySelector("input").focus();
      }, 500);
    });
    
    document.querySelector(".full-search").addEventListener("click", function(e) {
        if (e.target.classList.contains("full-search")) {
            document.querySelector(".full-search").classList.remove("search-active");
        }
    });
    document.querySelector(".inp-text-remove").addEventListener("click", function() {
      document.querySelectorAll(".inp input[type=text]").forEach(function(input) {
          input.value = "";
      });
      document.querySelector(".full-search").classList.remove("search-active");
    });
  };

  const init = () => {
    menu();
    mobileHamburger();
    headerSearch();
  };

  return {
    init,
  };
})();

export default header;
